import {Injector} from '@angular/core';

let appInjectorRef: Injector;
export const appInjector = (injector?: Injector): Injector => appInjectorRef ? appInjectorRef : appInjectorRef = injector;
